import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from './modules/auth/auth.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiModule } from 'openapi/build/api.module';
import { apiConfigFactory } from './services/config/api-configuration.service';
import { MaterialLayoutModule } from './modules/material-layout/material-layout.module';
import { ToastrModule } from 'ngx-toastr';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from './commun/CustomPaginator';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import { NgxMaskDirective, provideNgxMask, type NgxMaskOptions } from 'ngx-mask';
import localeFr from '@angular/common/locales/fr';
import { roleInterceptorProvider } from './HttpInterceptor/RoleInterceptorProvider';
import { ImarcheToken } from './marche/services/imarche.token';
import { MarcheAdapterService } from './marche/services/marche-adapter.service';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';

registerLocaleData(localeFr);
export const maskConfig: Partial<NgxMaskOptions> = {
  validation: false
};


